var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "512,215.579 296.421,215.579 296.421,0 215.579,0 215.579,215.579 0,215.579 0,296.421    215.579,296.421 215.579,512 296.421,512 296.421,296.421 512,296.421  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M160,89.376c-13.345,1.342-26.42,2.687-39.513,4.032c1.345-13.095,2.69-26.17,4.033-39.513   c-12.239,1.583-24.589,1.583-36.828,0c1.342,13.345,2.687,26.42,4.033,39.513c-13.094-1.345-26.17-2.689-39.514-4.032   c1.583,12.237,1.583,24.589,0,36.826c13.345-1.342,26.42-2.687,39.514-4.032c-1.346,13.095-2.691,26.17-4.033,39.513   c12.239-1.583,24.589-1.583,36.828,0c-1.343-13.345-2.688-26.42-4.033-39.513c13.094,1.345,26.17,2.689,39.513,4.032   C158.417,113.966,158.417,101.613,160,89.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M461,89.376c-13.345,1.342-26.42,2.687-39.513,4.032c1.345-13.095,2.69-26.17,4.033-39.513   c-12.239,1.583-24.589,1.583-36.828,0c1.342,13.345,2.687,26.42,4.033,39.513c-13.094-1.345-26.17-2.689-39.514-4.032   c1.583,12.237,1.583,24.589,0,36.826c13.345-1.342,26.42-2.687,39.514-4.032c-1.346,13.095-2.691,26.17-4.033,39.513   c12.239-1.583,24.589-1.583,36.828,0c-1.343-13.345-2.688-26.42-4.033-39.513c13.094,1.345,26.17,2.689,39.513,4.032   C459.417,113.966,459.417,101.613,461,89.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M160,385.797c-13.345,1.342-26.42,2.687-39.513,4.032c1.345-13.095,2.69-26.17,4.033-39.513   c-12.239,1.583-24.589,1.583-36.828,0c1.342,13.345,2.687,26.42,4.033,39.513c-13.094-1.345-26.17-2.689-39.514-4.032   c1.583,12.237,1.583,24.589,0,36.826c13.345-1.342,26.42-2.687,39.514-4.032c-1.346,13.095-2.691,26.17-4.033,39.513   c12.239-1.583,24.589-1.583,36.828,0c-1.343-13.345-2.688-26.42-4.033-39.513c13.094,1.345,26.17,2.689,39.513,4.032   C158.417,410.387,158.417,398.034,160,385.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M461,385.797c-13.345,1.342-26.42,2.687-39.513,4.032c1.345-13.095,2.69-26.17,4.033-39.513   c-12.239,1.583-24.589,1.583-36.828,0c1.342,13.345,2.687,26.42,4.033,39.513c-13.094-1.345-26.17-2.689-39.514-4.032   c1.583,12.237,1.583,24.589,0,36.826c13.345-1.342,26.42-2.687,39.514-4.032c-1.346,13.095-2.691,26.17-4.033,39.513   c12.239-1.583,24.589-1.583,36.828,0c-1.343-13.345-2.688-26.42-4.033-39.513c13.094,1.345,26.17,2.689,39.513,4.032   C459.417,410.387,459.417,398.034,461,385.797z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/GE.f4ef449e4b94ec55098bf88fe7fe84ef.svg";
export { ForwardRef as ReactComponent };